<template>
  <div class="db__container">
    <div class="db__container-left">
      <div class="dashboard__overview-top">
        <div class="dashboard__overview-card">
          <p class="dashboard__overview-card-number">
            {{
              dashboard.activeSubscriptions ? dashboard.activeSubscriptions : 0
            }}
          </p>
          <div class="dashboard__overview-active-icon-wrap">
            <svgicon
              v-if="!loader"
              icon="active-sub"
              class="dashboard__overview-active-icon"
            >
            </svgicon>
            <svgicon
              icon="spinner"
              v-if="loader"
              class="button__loader dashboard__overview-active-icon"
            ></svgicon>
          </div>
          <p class="dashboard__overview-card-text">Active Subscriptions</p>
        </div>
        <div class="dashboard__overview-card">
          <p class="dashboard__overview-card-number">
            {{ dashboard.pendingBookings ? dashboard.pendingBookings : 0 }}
          </p>
          <div class="dashboard__overview-booking-icon-wrap">
            <svgicon
              v-if="!loader"
              icon="listing_icon"
              class="dashboard__overview-booking-icon"
            ></svgicon>
            <svgicon
              icon="spinner"
              v-if="loader"
              class="button__loader dashboard__overview-active-icon"
            ></svgicon>
          </div>
          <p class="dashboard__overview-card-text">Bookings Pending</p>
        </div>
        <div class="dashboard__overview-card">
          <p class="dashboard__overview-card-number">
            {{ dashboard.approvedListings ? dashboard.approvedListings : 0 }}
          </p>
          <div class="dashboard__overview-listing-icon-wrap">
            <svgicon
              v-if="!loader"
              icon="approve"
              class="dashboard__overview-listing-icon"
            ></svgicon>
            <svgicon
              icon="spinner"
              v-if="loader"
              class="button__loader dashboard__overview-active-icon"
            ></svgicon>
          </div>
          <p class="dashboard__overview-card-text">Approved Listing(s)</p>
        </div>
        <div class="dashboard__overview-card">
          <p
            class="dashboard__overview-card-number"
            v-html="
              formatAmount(
                dashboard.monthlyTurnover ? this.dashboard.monthlyTurnover : 0
              )
            "
          ></p>
          <div class="dashboard__overview-earning-icon-wrap">
            <svgicon
              v-if="!loader"
              icon="monthly-income"
              class="dashboard__overview-earning-icon"
            ></svgicon>
            <svgicon
              icon="spinner"
              v-if="loader"
              class="button__loader dashboard__overview-active-icon"
            ></svgicon>
          </div>
          <p class="dashboard__overview-card-text">Earnings this month</p>
        </div>
        <div class="dashboard__overview-card">
          <p class="dashboard__overview-card-number">10</p>
          <div class="dashboard__overview-earning-icon-wrap">
            <svgicon
              v-if="!loader"
              icon="earnings_icon"
              class="dashboard__overview-earning-icon"
            ></svgicon>
            <svgicon
              icon="spinner"
              v-if="loader"
              class="button__loader dashboard__overview-active-icon"
            ></svgicon>
          </div>
          <p class="dashboard__overview-card-text">Total Earnings</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrencyAmount } from "../../utils/index";
import { getDashboard } from "../../../services/dashboard";

export default {
  name: "dashboard",

  data() {
    return {
      dashboard: {},
      loader: false
    };
  },
  methods: {
    getData() {
      this.loader = true;
      getDashboard()
        .then(data => {
          this.loader = false;

          if (data.statusCode == 200) {
            this.dashboard = data.data;
          }
        })
        .catch(err => {
          this.loader = false;
          return err;
        });
    },

    formatAmount(data) {
      return formatCurrencyAmount(data);
    }
  },

  mounted() {
    this.getData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue